import React from 'react';
import { SnackbarProvider, ThemeProvider } from 'fronton-react';
import { CssBaseline, Snackbar } from 'common/components';
import { BannersCarousel } from 'features/banners-carousel';
import { BannersCarouselWidgetProps } from './types';

export const BannersCarouselWidget: React.FC<BannersCarouselWidgetProps> = ({ ...props }) => {
  return (
    <React.Suspense>
      <ThemeProvider>
        <CssBaseline />
        <SnackbarProvider>
          <BannersCarousel {...props} />
          <Snackbar />
        </SnackbarProvider>
      </ThemeProvider>
    </React.Suspense>
  );
};
